export default "__VITE_ASSET__pxId4LnB__"